import { EMPTY } from "rxjs";
import { ZOHO_OPPORTUNITY_BASE_PATH, ZOHO_PHASE_BASE_PATH } from "../constants/zoho";

import Api from "./api";
import { ENV } from "../constants/env";

export default class ZohoApi {
    static enabled = ENV.ZOHO.enabled;

    static URL_OPPORTUNITY = ZOHO_OPPORTUNITY_BASE_PATH;

    static URL_PHASE = ZOHO_PHASE_BASE_PATH;

    static channelCrossSoat = "crosssoat";

    static channelValueCrossSoat = "CrossEcommerce";

    static HEADER = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Ocp-Apim-Subscription-Key": ENV.SUBSCRIPTION_KEY,
    };

    static validateChannel(channel) {
        if (channel === this.channelCrossSoat) {
            return this.channelValueCrossSoat;
        }
        return channel;
    }

    static add(body, token, requestId) {
        if (!ZohoApi.enabled) {
            return EMPTY;
        }
        return Api.post(`opportunities`, {
            host: `${ENV.API_MANAGEMENT_URL}${this.URL_OPPORTUNITY}`,
            data: {
                ecommerceName: ENV.ZOHO.ECOMMERCE_NAME,
                jsonRequest: JSON.stringify(body),
                idEcommerce: requestId,
            },
            customHeader: {
                ...this.HEADER,
                Authorization: token,
            },
        });
    }

    static addUpdate(param, zohoCrmId, token) {
        if (!ZohoApi.enabled) {
            return EMPTY;
        }
        const body = { ...param, id: zohoCrmId };
        return Api.post(`phases`, {
            host: `${ENV.API_MANAGEMENT_URL}${this.URL_PHASE}`,
            data: {
                ecommerceName: ENV.ZOHO.ECOMMERCE_NAME,
                zohoId: zohoCrmId,
                jsonRequest: JSON.stringify(body),
            },
            customHeader: {
                ...this.HEADER,
                Authorization: token,
            },
        });
    }
}
